import { el } from "../utils/dom.ts";
import { getHealth } from "../services/api-client.ts";

// Global staleness indicator. Polls /health; shows a warning pill when any source
// (price, news, or briefs) is stale. Covers the whole data surface (red-team #1).
export class SourceStatusBadge {
  readonly el: HTMLElement;

  constructor() {
    this.el = el("div", { className: "status-badge ok" }, ["● dữ liệu trực tiếp"]);
  }

  async refresh(): Promise<void> {
    try {
      const h = await getHealth();
      const staleSources = h.sources.filter((s) => s.stale || !s.ok).map((s) => s.source);
      const staleAxes: string[] = [];
      if (staleSources.length) staleAxes.push("giá");
      if (h.news.stale) staleAxes.push("tin");
      if (h.briefs.stale) staleAxes.push("phân tích");

      if (staleAxes.length === 0) {
        this.el.className = "status-badge ok";
        this.el.textContent = "● dữ liệu trực tiếp";
      } else {
        this.el.className = "status-badge stale";
        this.el.textContent = `● dữ liệu cũ: ${staleAxes.join(", ")}`;
      }
    } catch {
      this.el.className = "status-badge error";
      this.el.textContent = "● mất kết nối";
    }
  }

  start(): void {
    void this.refresh();
    setInterval(() => void this.refresh(), 60_000);
  }
}
